



















import { Vue, Component, Prop } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';

@Component({
  components: {
    CabeceraModal,
  },
})
export default class CabeceraModalDevolucionCrear extends Vue {
  @Prop({ default: false }) permitirGuard: Boolean;
  @Prop({ default: true }) mostrarBtnContinuarCrear: Boolean;

  guard() {
    this.$emit('guardarCrear');
  }
}
